<!--
 * @Author: yezi
 * @Date: 2020-03-16 15:31:14
 * @LastEditors: yezi
 * @LastEditTime: 2020-03-16 15:52:59
 * @Description:
 -->
<template>
  <div id="app">

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 page1,page2 -->
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不被缓存的视图组件，比如 page3 -->
    </router-view>
  </div>
</template>

<script>
export default {
  // // 解决安卓手机调出来软键盘，屏幕背景被挤压的问题
  created () {
    // 获取当前可视区域的高度
    const height = document.documentElement.clientHeight
    // 在页面整体加载完毕时
    window.onload = function () {
      // 把获取到的高度赋值给根div
      document.getElementById('app').style.height = `${height}px`
    }
  }
}
</script>
<style>
#app {
  /* padding: 0 0.2rem; */
  /* margin: auto; */
  /* max-width: 750px; */
  /* background: blue; */
}
div ,span, p, ul, li,a {
  user-select: none;
}
</style>
